import { jsx as _jsx } from "react/jsx-runtime";
function IconContactFilled(props) {
    return (_jsx("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-xds": "IconContactFilled", ...props, children: _jsx("path", { d: "M13.217 15c3.432 0 5.68 3.262 5.78 5.823L19 21H5c0-2.526 2.169-5.845 5.546-5.995l.237-.005h2.434zM12 3a5 5 0 100 10 5 5 0 000-10z", fill: "currentColor" }) }));
}
export default IconContactFilled;
//# sourceMappingURL=IconContactFilled.js.map